import { useEffect, useMemo } from 'react'
import { useTimer } from 'react-timer-hook'


import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'


interface ButtonDelayProps {
  className?: string;
  children: React.ReactNode;
  duration: number; // ms
  onFinish?: () => void;
  onClick?: () => void;
}

export default function ButtonDelay (props: ButtonDelayProps) {
  const { className, children, duration, onFinish, onClick } = props

  const seconds = Math.ceil(duration / 1000)

  const expiryTimestamp = useMemo(() => {
    const time = new Date()
    time.setSeconds(time.getSeconds() + seconds)
    return time
  }, [ duration ])

  const { restart } = useTimer({
    expiryTimestamp,
    autoStart: true,
    onExpire: () => {
      onFinish?.()
    },
  })

  useEffect(() => {
    const newExpiry = new Date()
    newExpiry.setMilliseconds(newExpiry.getMilliseconds() + duration)
    restart(newExpiry)
  }, [ duration, restart ])

  return (
    <Button
      className={cn(styles.root, className)}
      theme="grey"
      style={{ '--duration': `${duration}ms` } as React.CSSProperties}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
